import { Navigate, Outlet } from 'react-router-dom';

import { routes } from '@/config/routes';
import { useAuth } from '@/providers/auth-provider';

export function RedirectIfAuthenticated() {
  const { status } = useAuth();
  if (status === 'authenticated') return <Navigate to={routes.dashboard} replace />;
  return <Outlet />;
}
